const emptyFeatureCollection = () => ({
    type: 'FeatureCollection',
    features: [],
});
const isFeatureCollection = (value) => {
    return Boolean(value &&
        typeof value === 'object' &&
        Array.isArray(value.features));
};
export class JobFeature {
    constructor(job, index) {
        this.jobId =
            typeof job.job_id === 'string'
                ? job.job_id
                : `unknown-job-${String(index)}`;
        this.jobNumber = typeof job.job_number === 'number' ? job.job_number : 0;
        this.geoJson = isFeatureCollection(job.geo_json)
            ? job.geo_json
            : emptyFeatureCollection();
    }
}
export class MultiJobGeoJsonResponse {
    constructor(payload) {
        const response = payload && typeof payload === 'object'
            ? payload
            : {};
        this.locations = isFeatureCollection(response.locations)
            ? response.locations
            : emptyFeatureCollection();
        this.jobs = Array.isArray(response.jobs)
            ? response.jobs.map((job, index) => new JobFeature(job ?? {}, index))
            : [];
    }
}
//# sourceMappingURL=MultiJobGeoJsonResponse.js.map